__turbopack_context__.v({
  "hash-tabs-navigation-skeleton": "XWcQFG_hash-tabs-navigation-skeleton",
  "tab-panel-skeleton": "XWcQFG_tab-panel-skeleton",
  "tab-panel-skeleton__button": "XWcQFG_tab-panel-skeleton__button",
  "tab-panel-skeleton__button-container": "XWcQFG_tab-panel-skeleton__button-container",
  "tab-panel-skeleton__heading": "XWcQFG_tab-panel-skeleton__heading",
  "tab-panel-skeleton__link": "XWcQFG_tab-panel-skeleton__link",
  "tab-panel-skeleton__links": "XWcQFG_tab-panel-skeleton__links",
  "tab-panel-skeleton__text": "XWcQFG_tab-panel-skeleton__text",
  "tabs-navigation-skeleton__list": "XWcQFG_tabs-navigation-skeleton__list",
  "tabs-navigation-skeleton__menu-button": "XWcQFG_tabs-navigation-skeleton__menu-button",
  "tabs-navigation-skeleton__menu-button-container": "XWcQFG_tabs-navigation-skeleton__menu-button-container",
  "tabs-navigation-skeleton__skeleton-item": "XWcQFG_tabs-navigation-skeleton__skeleton-item",
});
